var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from "@ngrx/effects";
import { ProfileActionTypes, ProfileRestore, ProfileUpdateSuccess } from "./profile.actions";
import { filter, map } from "rxjs/operators";
import * as fromAuth from "../auth";
import { Store } from "@ngrx/store";
var ProfileEffects = /** @class */ (function () {
    function ProfileEffects(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.profileUpdate$ = this.actions$.pipe(ofType(ProfileActionTypes.ProfileUpdate), map(function (_) { return _.payload; }), 
        // tap(data => this.uid = data.uid),
        // @todo save in databse
        map(function (data) { return new ProfileUpdateSuccess(data); }));
        this.effect$ = this.actions$.pipe(ofType(fromAuth.AuthActionTypes.AuthTokenPayload), filter(function (_) { return !!_; }), map(function (_) { return _.payload; }), 
        // @todo restore profile data
        map(function (data) { return new ProfileRestore(data); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], ProfileEffects.prototype, "profileUpdate$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], ProfileEffects.prototype, "effect$", void 0);
    return ProfileEffects;
}());
export { ProfileEffects };
